import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AuthService } from '../../core/services/auth';
import { UserService } from '../../core/services/user.service';

@Component({
  selector: 'app-subscription-inactive',
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule, ToastModule],
  providers: [MessageService],
  templateUrl: './subscription-inactive.component.html',
  styleUrl: './subscription-inactive.component.scss'
})
export class SubscriptionInactiveComponent {
  message: string = '';
  userRole: string = '';
  checking: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService,
    private userService: UserService
  ) {
    // Get the message from navigation state or use default
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;
    
    this.message = state?.['message'] || 'Your organization\'s subscription is inactive. Please contact your administrator to renew it.';
    this.userRole = state?.['userRole'] || '';
  }

  checkSubscriptionAgain() {
    this.checking = true;
    this.messageService.add({
      severity: 'info',
      summary: 'Checking',
      detail: 'Verifying subscription status...'
    });
    
    // Check subscription status without logging out
    this.userService.checkSubscriptionStatus().subscribe({
      next: (subscriptionStatus) => {
        this.checking = false;
        
        if (subscriptionStatus.isValid) {
          // Subscription is now active!
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Your subscription is now active! Redirecting to dashboard...',
            life: 3000
          });
          
          setTimeout(() => {
            this.router.navigate([this.getDashboardRoute()]);
          }, 1500);
        } else {
          // Still inactive
          this.messageService.add({
            severity: 'warn',
            summary: 'Still Inactive',
            detail: subscriptionStatus.message,
            life: 5000
          });
        }
      },
      error: (error) => {
        this.checking = false;
        console.error('Error checking subscription:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to check subscription status. Please try again.',
          life: 5000
        });
      }
    });
  }

  logout() {
    this.messageService.add({
      severity: 'info',
      summary: 'Logging Out',
      detail: 'Taking you back to login...'
    });
    
    // Logout and redirect to login
    this.authService.logout();
    setTimeout(() => {
      this.router.navigate(['/']);
    }, 500);
  }

  contactSupport() {
    this.messageService.add({
      severity: 'info',
      summary: 'Contact Support',
      detail: 'Please reach out to your system administrator for assistance.'
    });
  }

  private getDashboardRoute(): string {
    switch (this.userRole) {
      case 'FSR':
        return '/admin/fsr-dashboard';
      case 'A':
        return '/admin/admin-dashboard';
      case 'CSM':
      case 'SM':
        return '/admin/user-management';
      default:
        return '/admin/user-management';
    }
  }
}

